module.exports = __webpack_public_path__ + "static/media/privacy-policy-production-231019.fce87446.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/privacy-policy-production-231019.pdf
// module id = 655
// module chunks = 0